import request from '@/http/request'
import{  
    getSelectPlan,
    getPlanCourse,
    scoredRuleResultList,
    scoredRuleResultExport
} from '@/http/api'


export const getSelectPlanFn = (data) => {
  return request({
    url: getSelectPlan,
    data,
  })
}

export const getPlanCourseFn = (data) => {
  return request({
    url: getPlanCourse,
    data,
  })
}

export const scoredRuleResultListFn = (data) => {
  return request({
    url: scoredRuleResultList,
    data,
  })
}

export const scoredRuleResultExportFn = (data) => {
  return request({
    url: scoredRuleResultExport,
    data,
  })
}